export default __webpack_public_path__ + "static/avatar-paul-1f18001c8b853eb132bf84376a952cec.png";